import { ReactComponent as EyeIcon } from "../../images/eye.svg";

const DataList = props => {
  const list = props.list;

  const handleClick = action => {
    if (!action) {
      return;
    }

    if (typeof action === "function") {
      action();
    }
  };

  return (
    <div className="data-list">
      {list.map(item => {
        return (
          <div className="row flex flex-v-center" key={item.title}>
            <div className="info">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
            <div
              className="action flex flex-v-center"
              onClick={() => handleClick(item.action)}
            >
              <div className="text">{item.value}</div>
              <div
                className={`action-button flex flex-center ${
                  item.action ? "" : "disabled"
                }`}
                style={{ marginLeft: "0.5rem" }}
              >
                <EyeIcon />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DataList;
